import "./SidebarLibraryCookies.css";

const SidebarLibraryCookies = () => {
    return (
        <section className="sidebar__navegation__cookies">
            <a href="https://www.spotify.com/br-pt/legal/cookies-policy/" target="_blank" rel="noreferrer">
                Cookies
            </a>
        </section>
    );
}

export default SidebarLibraryCookies;